import get from "lodash.get";

/**
 * Super admin uchungina ochiladigan bo'limlar shu id ga bog'langan.
 * Backend `admin.isSuperAdmin` ni qaytara boshlasa, o'sha maydon ustun turadi.
 */
export const SUPER_ADMIN_USER_ID = "698328412bfacc1035cdda9f";

const readAdmin = (): Record<string, any> | null => {
  try {
    const raw = localStorage.getItem("admin");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const isSuperAdmin = (): boolean => {
  const admin = readAdmin();
  if (!admin) return false;

  const flag = get(admin, "isSuperAdmin", get(admin, "admin.isSuperAdmin"));
  if (typeof flag === "boolean") return flag;

  const id = get(admin, "_id", get(admin, "admin._id"));
  return id === SUPER_ADMIN_USER_ID;
};
